export default __webpack_public_path__ + "static/media/Purple-BG-End.d27a60a8.svg";